import { useCallback, useMemo } from "react";
import {
  useOrganizationsQuery,
  OrganizationType,
} from "@/features/organization/graphql/generated";
import useOrgNavigate from "@/shared/utils/router/useOrgNavigate";
import { useViewer } from "@/features/profile/hooks/useViewer";
import { toNumber } from "lodash";

export const useOrganisations = (accountId?: number | null) => {
  const navigate = useOrgNavigate();
  const { viewer } = useViewer();

  const account_id = accountId || viewer?.default_account_id || undefined;

  const { data, loading } = useOrganizationsQuery({
    variables: { account_id: toNumber(account_id) },
    skip: !account_id,
  });

  const organizations = useMemo(
    () => (data?.organizations as OrganizationType[]) || [],
    [data?.organizations]
  );

  const handleOrganisationSelect = useCallback(
    (organisation: OrganizationType) => {
      window.localStorage.setItem(
        "recentOrg",
        organisation?.id?.toString() || ""
      );

      // Check if there's a saved redirect URL from account switch mismatch
      const redirectUrl = localStorage.getItem("accountSwitchRedirect");
      if (redirectUrl) {
        localStorage.removeItem("accountSwitchRedirect");
        navigate(redirectUrl);
        return;
      }

      navigate("/dashboard");
      window.location.reload();
    },
    [navigate]
  );

  return {
    organizations,
    loading,
    handleOrganisationSelect,
  };
};
